module.exports = __webpack_public_path__ + "static/media/Ellipse2.c81e2743.png";